import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { Membership, MembershipType } from '@/models/user';
import { isEmpty } from '@/utils/misc';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OtherMembershipsSummarySection',
  props: {
    memberships: null
  },
  setup(__props: any) {

const props = __props as {
  memberships: Membership[];
};



const { t } = useI18n();

function getMembershipsOfType(type: MembershipType): Membership[] {
  return props.memberships.filter((membership) => membership.type === type);
}

const subsidiaryMemberships = computed(() =>
  getMembershipsOfType(MembershipType.Subsidiary),
);

const customerMemberships = computed(() =>
  getMembershipsOfType(MembershipType.Customer),
);

const hasSubsidiaryMemberships = computed(
  () => !isEmpty(subsidiaryMemberships.value),
);

const hasCustomerMemberships = computed(
  () => !isEmpty(customerMemberships.value),
);

return { __sfc: true,props, t, getMembershipsOfType, subsidiaryMemberships, customerMemberships, hasSubsidiaryMemberships, hasCustomerMemberships }
}

})